import { Trash2, Plus, Minus, MessageCircle } from 'lucide-react'
import useFormatPrice from '@hooks/useFormatPrice'
import UseWhatsapp from 'whatsapp-react-component'
import SocialLinks from '@components/SocialLinks'
import styles from '@styles/CartPage.module.css'
import TermsModal from '@components/TermsModal'
import { useCart } from '@context/CartContext'
import { useState, useEffect } from 'react'
import Navbar from '@components/Navbar'

const CartPage = () => {
  const { cart, removeFromCart, updateQuantity, clearCart, getCartTotal } = useCart()
  const [selectedAction, setSelectedAction] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [products, setProducts] = useState([])
  const formatPrice = useFormatPrice()
  const whatsappNumber = '573223110646'

  useEffect(() => {
    setProducts(cart)
  }, [cart])

  const openModal = action => {
    setSelectedAction(action)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedAction(null)
  }

  const handleAcceptTerms = () => {
    if (selectedAction === 'whatsapp') {
      const greeting =
        '¡Hola! Gracias por tu interés en nuestros productos. A continuación, te detallo tu pedido:\n\n'
      const message = products.map(product =>
            `📦 *Producto:* ${product.brand}\n` +
            `📝 *Referencia:* ${product.reference}\n` +
            `🔢 *Cantidad:* ${product.quantity}\n` +
            `💰 *Precio unitario:* ${formatPrice(product.price)}\n` +
            `*Subtotal:* ${formatPrice(product.price * product.quantity)}`
        ).join('\n\n')
      const totalMessage = `\n\n💳 *Total del pedido:* ${formatPrice(getCartTotal())}`
      const footer = '\n\n¿Te gustaría proceder con tu compra? Estaremos encantados de atenderte. 😊'
      const fullMessage = `${greeting}${message}${totalMessage}${footer}`
      UseWhatsapp(whatsappNumber, fullMessage)
    }
    closeModal()
  }

  const handleQuantityChange = (id, newQuantity) => {
    newQuantity > 0 && updateQuantity(id, newQuantity)
  }

  return (
    <div className={styles.cartPage}>
      <Navbar className={styles.cartNavbar} />
      <main className={styles.mainContent}>
        <h1 className={styles.title}>Mi Carrito</h1>
        {products.length === 0 ? (
          <p className={styles.emptyMessage}>Tu carrito está vacío.</p>
        ) : (
          <>
            <div className={styles.cartItems}>
              {products.map((product) => (
                <div key={product.id} className={styles.cartItem}>
                  <img
                    src={product.image || '/placeholder.svg'}
                    alt={product.reference}
                    className={styles.productImage}
                  />
                  <div className={styles.productInfo}>
                    <h3>{product.brand}</h3>
                    <p>{product.reference}</p>
                    <p>{formatPrice(product.price)}</p>
                  </div>
                  <div className={styles.quantityControl}>
                    <button onClick={() => handleQuantityChange(product.id, product.quantity - 1)} >
                      <Minus size={16} />
                    </button>
                    <span>{product.quantity}</span>
                    <button onClick={() => handleQuantityChange(product.id, product.quantity + 1)} >
                      <Plus size={16} />
                    </button>
                  </div>
                  <button className={styles.removeButton} onClick={() => removeFromCart(product.id)} >
                    <Trash2 size={16} />
                  </button>
                </div>
              ))}
            </div>
            <div className={styles.cartSummary}>
              <p>Total: {formatPrice(getCartTotal())}</p>
            </div>
              <button onClick={clearCart} className={styles.clearCartButton}>
                Vaciar carrito
              </button>
              <button className={styles.checkoutButton} onClick={() => openModal('whatsapp')}>
                <MessageCircle size={20} />
                Comprar por WhatsApp
              </button>
            </>
        )}
      </main>
      <footer className={styles.footer}>
        <SocialLinks />
      </footer>
      <TermsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onAccept={handleAcceptTerms}
        productTitle='Carrito de Compras'
      />
    </div>
  )
}

export default CartPage
